import React from 'react';
import cx from './index.module.scss';

const About = () => {
  return (
    <section className={cx.wrap}>
      <img className={cx.image} src={`${process.env.PUBLIC_URL}/images/image_blind.svg`} alt="" />
      <div className={cx.title}><span>블라인드 지수란?</span></div>
      <div className={cx.body}>
        <p>블라인드 지수는 재직중인 임직원이 직접 평가한 ‘우리 회사의 재직자 행복지수’ 입니다.</p>
        <p>행복 지수에 영향을 미치는 12가지 요소를 함께 발표하고 있고, 이 요소들은 모두 기업에서 대응이 가능한 항목으로 이루어져 있습니다.</p>
        <p>블라인드 지수가 기업이 자사의 직장 문화에 대해 정확한 진단을 내리고, 임직원이 행복한 직장 문화를 만드는데 도움이 되기를 바랍니다.</p>
      </div>
      <a href="https://www.teamblind.kr" className={cx.link}>블라인드가 왜 이런 것을 할까? 궁금하신가요?</a>
    </section>
  )
};

export default About;
